import { render, staticRenderFns } from "./NeedOpenRedBag.vue?vue&type=template&id=25724e3a&scoped=true"
import script from "./NeedOpenRedBag.vue?vue&type=script&lang=js"
export * from "./NeedOpenRedBag.vue?vue&type=script&lang=js"
import style0 from "./NeedOpenRedBag.vue?vue&type=style&index=0&id=25724e3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25724e3a",
  null
  
)

export default component.exports